import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { variantMap, Heading } from '@grandvisionhq/elements';
import { parseHtml, domToReact } from '@grandvisionhq/lib-utils-html';
import { colorHexMap } from '../Util/color-map.js';
import 'lodash/uniq';
import '@grandvisionhq/utils';
import '../MediaQuery/MediaQueryContext.js';
import '../Util/get-donation-foundation-icon.js';
import { isElement, isDomNode, isChildNodeElement, isAlignment } from './typeguards.js';

const regHex = /#([a-f0-9]{3}){1,2}\b/i;
const regPresetBg = /black|grey|white/;
// Somehow leaving out the ternary below causes an error in the SelectToggleButton test suite
const variantReverseMap = variantMap ? Object.entries(variantMap).reduce((acc, [key, value])=>swcHelpers.objectSpread({}, acc, {
        [value]: key
    })
, {}) : {};
const getOptions = (textColor)=>{
    let rowIndex = 0;
    //TODO: With React18, we need to use here the useId() hook to create a unique id per table,
    // so we can support more than one per page
    // Example: `${idFromTheReactHook}_${rowIndex}_${columnIndex}`
    return {
        replace: (domNode)=>{
            if (isElement(domNode) && domNode.name in variantReverseMap) {
                var ref;
                let align = 'left';
                if ((ref = domNode.attribs.style) === null || ref === void 0 ? void 0 : ref.includes('text-align')) {
                    const styles = domNode.attribs.style.split(';');
                    const textAlign = styles.find((s)=>s.includes('text-align')
                    );
                    const [_, value] = textAlign ? textAlign.split(':').map((s)=>s.trim()
                    ) : [];
                    align = value && isAlignment(value) ? value : 'left';
                }
                const childElements = domNode.children.filter(isDomNode);
                return /*#__PURE__*/ React.createElement(Heading, {
                    variant: variantReverseMap[domNode.name],
                    align: align,
                    color: textColor === 'white' ? 'alt' : undefined
                }, domToReact(childElements)); //
            // This block of code handles the creation of accessibility attributes for a table created using RichText
            } else if (isElement(domNode) && domNode.name === 'tr') {
                const childElements = Array.from(domNode.children).filter(isChildNodeElement);
                const rowWithHeaders = childElements.find((element)=>element.name === 'th'
                );
                const isHeaderRow = rowWithHeaders !== undefined;
                // Iterate through each child element (table cells) within the current row
                domNode.children.forEach((child, columnIndex)=>{
                    if (isChildNodeElement(child)) {
                        if (child.name === 'th') {
                            var ref;
                            const previousElement = (ref = child.prev) === null || ref === void 0 ? void 0 : ref.prev;
                            if (child.attribs.rowspan && parseInt(child.attribs.rowspan) > 1) {
                                // If the <th> element spans multiple rows, set the 'scope' attribute.
                                child.attribs.scope = 'rowgroup';
                            } else if (previousElement && isChildNodeElement(previousElement) && previousElement.attribs.id) {
                                // If the <th> element doesn't span rows, associate it with the previous element's 'id'.
                                child.attribs.headers = previousElement.attribs.headers || previousElement.attribs.id;
                            }
                            // Assign a unique 'id' to the <th> element for reference
                            child.attribs.id = `${rowIndex}_${columnIndex}`;
                        } else if (!isHeaderRow && child.name === 'td') {
                            // For data cells (<td>), calculate the 'headers' attribute to associate them with header cells
                            // Calculate the 'headers' attribute for data cells
                            // 'rowIndex - 1' is used to reference the previous row
                            // 'columnIndex + 2' accounts for the presence of <th> elements in the current row
                            child.attribs.headers = `${rowIndex - 1}_${columnIndex + 2}`;
                        }
                    }
                });
                // Increment the rowIndex to keep track of table row index
                rowIndex++;
            }
            return domNode;
        }
    };
};
const RichTextArea = ({ id , content , className , textColor ='black' , backgroundColor ='transparent' , fullWidth , isContained , 'data-t': dataT  })=>{
    const classNames = classnames('rich-text-area', `rich-text-area--text-${textColor}`, {
        'rich-text-area--full-width': fullWidth
    }, {
        'rich-text-area--contained': isContained
    }, className);
    const richTextAreaStyle = {
        backgroundColor: regHex.test(backgroundColor) ? backgroundColor : regPresetBg.test(backgroundColor) ? colorHexMap[backgroundColor] : 'transparent'
    };
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        id: id,
        className: classNames,
        style: richTextAreaStyle
    }, dataT && {
        'data-t': dataT
    }), parseHtml(content, getOptions(textColor)));
};

export { RichTextArea, RichTextArea as default };
//# sourceMappingURL=RichTextArea.js.map
